import { useMountEffect } from "@react-hookz/web";
import React, { useMemo, useState } from "react";
import { CloseButton } from "~/components/acquisition-popup-container/display/popups/common/close-button";
import { PopupBackdrop } from "~/components/acquisition-popup-container/display/styles";
import { useSdkContext } from "~/components/contexts";
import { Modal } from "~/components/modal";
import { NewsletterWidget } from "~/components/newsletter/newsletter-widget";
import { Variant as NewsletterVariant } from "~/components/newsletter/newsletter-widget/enums";
import { Container, ContentContainer, Description, ImageContainer, Title } from "./styles";
export const AcquisitionNewsletterPopup = ({
  acquisition,
  modalContainerReference,
  onClose
}) => {
  const {
    description,
    image,
    title
  } = acquisition.content;
  const newsletterItems = useMemo(() => {
    var _ref, _acquisition$tids;
    return (_ref = acquisition.tid ? [{
      entityId: acquisition.tid,
      name: acquisition.name
    }] : (_acquisition$tids = acquisition.tids) === null || _acquisition$tids === void 0 ? void 0 : _acquisition$tids.map(tid => ({
      entityId: tid,
      name: acquisition.name
    }))) !== null && _ref !== void 0 ? _ref : [];
  }, [acquisition.name, acquisition.tid, acquisition.tids]);
  const {
    handleTrackGA4
  } = useSdkContext();
  const [isSuccess, setIsSuccess] = useState(false);
  const campaignName = acquisition.campaign;
  useMountEffect(() => {
    handleTrackGA4({
      action: "imp",
      category: "promopopup",
      customized_parameters: {
        cta_type: "nl_signup",
        internal_campaign: campaignName,
        step: "1"
      },
      subcategory: ""
    });
  });
  return /*#__PURE__*/React.createElement(Modal, {
    BackdropComponent: PopupBackdrop,
    container: modalContainerReference === null || modalContainerReference === void 0 ? void 0 : modalContainerReference.current,
    fadeTimeout: 400,
    open: true,
    "data-qa": "acquisition-newsletter-popup"
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(CloseButton, {
    onClose: () => {
      handleTrackGA4({
        action: "click",
        category: "promopopup",
        customized_parameters: {
          cta_type: "nl_signup",
          internal_campaign: campaignName,
          message: "close button",
          step: "1"
        },
        subcategory: ""
      });
      onClose === null || onClose === void 0 || onClose();
    }
  }), /*#__PURE__*/React.createElement(ImageContainer, null, /*#__PURE__*/React.createElement("img", {
    alt: title,
    src: image
  })), /*#__PURE__*/React.createElement(ContentContainer, null, !isSuccess && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Title, {
    dangerouslySetInnerHTML: {
      __html: title
    }
  }), /*#__PURE__*/React.createElement(Description, {
    dangerouslySetInnerHTML: {
      __html: description
    }
  })), /*#__PURE__*/React.createElement(NewsletterWidget, {
    campaignName: campaignName,
    multipleNewsletters: true,
    newsletterItems: newsletterItems,
    signUpButtonDisplayComponent: acquisition.button.text,
    variant: NewsletterVariant.AcquisitionNewsletterPopup,
    onSuccess: () => {
      setIsSuccess(true);
    }
  }))));
};
AcquisitionNewsletterPopup.displayName = "AcquisitionNewsletterPopup";